const GoogleIcon = () => (
  <svg className="icon" width={18} height={18}>
    <use xlinkHref="/assets/logos/icons.svg#GoogleIcon"></use>
  </svg>
);
export default GoogleIcon;
